import type { OptionsDocument, Pipeline } from 'paintscout'

export function deletePipeline(args: { options: OptionsDocument; pipeline: Pipeline }): OptionsDocument {
  const { options, pipeline } = args
  const key = pipeline.key

  const values = { ...options.options.pipelines?.values }
  if (values[key]) {
    values[key].deleted = true
  }

  return {
    ...options,
    options: {
      ...options.options,
      pipelines: {
        ...options.options.pipelines,
        values
      }
    }
  }
}

export function deletePipelines(args: { options: OptionsDocument; pipelines: Pipeline[] }): OptionsDocument {
  const { options, pipelines } = args
  return pipelines.reduce((acc, pipeline) => deletePipeline({ options: acc, pipeline }), options)
}
